'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import { ChatComp, ChatBoxComp, getCurrentMeeting, getDisplayModeState } from '../index'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lib = require('../../../mqttclient/lib/');

var _lib2 = _interopRequireDefault(_lib);

var _chat = require('../components/chat');

var _chat2 = _interopRequireDefault(_chat);

var _chatbox = require('../components/chatbox');

var _chatbox2 = _interopRequireDefault(_chatbox);

var _dock = require('../components/dock');

var _dock2 = _interopRequireDefault(_dock);

var _contacts = require('../components/contacts');

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _userservice = require('./userservice');

var _userservice2 = _interopRequireDefault(_userservice);

var _apiservice = require('./apiservice');

var _apiservice2 = _interopRequireDefault(_apiservice);

var _helpers = require('../common/helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChatService = function () {
    function ChatService() {
        var _this = this;

        _classCallCheck(this, ChatService);

        this.getMeeting = function () {
            return (0, _chat.getCurrentMeeting)();
        };

        this.nonWorkingHoursChatBox = function (config) {
            var style = config.style;
            var ele = config.container;
            var displayMode = config.display_mode;
            var showHeader = config.show_header;
            var showBody = config.show_body;
            var showFooter = config.show_footer;
            var onNonWorkingHourChatBoxMinimize = config.onNonWorkingHourChatBoxMinimize;

            var resizeNonWorkingChatBox = function resizeNonWorkingChatBox(displayMode) {
                console.log('Display mode ..}}}}}}}}}}}}}}}}}}}}}}}}}}', displayMode);
                if (displayMode === Constants.CHAT_WINDOW_STATE_MINIMIZED) {
                    if (onNonWorkingHourChatBoxMinimize) {
                        onNonWorkingHourChatBoxMinimize();
                    }
                } else if (displayMode === Constants.CHAT_WINDOW_STATE_FULLSCREEN) {
                    _reactDom2.default.render(_react2.default.createElement(
                        _chatbox2.default,
                        {
                            initialMessage: '',
                            chatteeName: 'test',
                            position: style.position,
                            skinName: style.skinName,
                            user_type: 'unknown',
                            chatElement: ele,
                            setDisplayMode: resizeNonWorkingChatBox,
                            nonWorkingHour: true,
                            nonWorkingHourDisplayMessage: config.nonWorkingHourDisplayMessage,
                            displayMode: displayMode,
                            showHeader: showHeader,
                            showBody: showBody,
                            showFooter: showFooter },
                        'Born on-demand'
                    ), document.getElementById(ele));
                } else if (displayMode === Constants.CHAT_WINDOW_STATE_NORMAL) {
                    _reactDom2.default.render(_react2.default.createElement(
                        _chatbox2.default,
                        {
                            initialMessage: '',
                            chatteeName: 'test',
                            position: style.position,
                            skinName: style.skinName,
                            user_type: 'unknown',
                            chatElement: ele,
                            setDisplayMode: resizeNonWorkingChatBox,
                            nonWorkingHour: true,
                            nonWorkingHourDisplayMessage: config.nonWorkingHourDisplayMessage,
                            displayMode: displayMode,
                            showHeader: showHeader,
                            showBody: showBody,
                            showFooter: showFooter },
                        'Born on-demand'
                    ), document.getElementById(ele));
                }
            };

            _reactDom2.default.render(_react2.default.createElement(
                _chatbox2.default,
                {
                    initialMessage: '',
                    chatteeName: 'test',
                    position: style.position,
                    skinName: style.skinName,
                    user_type: 'unknown',
                    chatElement: ele,
                    setDisplayMode: resizeNonWorkingChatBox,
                    nonWorkingHour: true,
                    nonWorkingHourDisplayMessage: config.nonWorkingHourDisplayMessage,
                    displayMode: displayMode,
                    showHeader: showHeader,
                    showBody: showBody,
                    showFooter: showFooter },
                'Born on-demand'
            ), document.getElementById(ele));
        };

        this.loadClientChat = function (config) {
            var client = config.visitor;
            var style = config.style;
            var ele = config.container;
            var custom_data = config.custom_data;
            var user_type = config.user_type;
            var userDetails = null;
            var participantsData = null;
            var displayMode = config.display_mode;
            var showHeader = config.show_header;
            var showBody = config.show_body;
            var showFooter = config.show_footer;
            var notificationId = config.notification_id;
            var options = null;
            var width = config.width;
            var height = config.height;
            var mask_user_typing_text = config.mask_user_typing_text;
            var mask_user_events = config.mask_user_events;

            _reactDom2.default.render(_react2.default.createElement(
                _chatbox2.default,
                {
                    initialMessage: '',
                    chatteeName: 'test',
                    position: style.position,
                    skinName: style.skinName,
                    user_type: 'unknown',
                    chatElement: ele,
                    displayMode: displayMode,
                    showHeader: showHeader,
                    showBody: showBody,
                    width: width,
                    height: height,
                    showFooter: showFooter },
                'Born on-demand'
            ), document.getElementById(ele));

            _userservice2.default.get().then(function (userData) {
                userDetails = userData;
                var currentMeeting = (0, _chat.getCurrentMeeting)();
                if (!(currentMeeting && currentMeeting.id)) {
                    return null;
                } else {
                    if (notificationId) {
                        options = {
                            "notification_id": notificationId
                        };
                    }
                    return _apiservice2.default.joinMeetingRequest(currentMeeting.id, options)
                    // update participants list in redux
                    .then(function (meetingData) {
                        if (meetingData.status !== 'failed') {
                            var participantsList = {
                                meetingId: meetingData.data.meeting_details.id,
                                participant_list: meetingData.data.participants
                            };
                            participantsData = participantsList;
                            return meetingData.data.meeting_details;
                        } else {
                            // If unable to join to existing meeting remove current meeting
                            if (meetingData.is_non_working_hours) {
                                config.nonWorkingHourDisplayMessage = meetingData.message;
                                _this.nonWorkingHoursChatBox(config);
                            }
                            return null;
                        }
                    });
                }
            }).then(function (currentMeeting) {
                if (currentMeeting && currentMeeting.status !== 'failed') {
                    if (!displayMode) {
                        displayMode = (0, _chat.getDisplayModeState)(currentMeeting.id);
                        // console.log("chatservice.js: ",displayMode)
                    }
                    return currentMeeting;
                } else {
                    options = { helpDetails: client.initialMessage, mode: "chat", custom_data: custom_data };
                    if (notificationId) {
                        options.notification_id = notificationId;
                    }

                    return _apiservice2.default.createMeetingRequest(options).then(function (meetingData) {
                        if (meetingData.status === 'success') {
                            var participantsList = {
                                meetingId: meetingData.data.id,
                                participant_list: [{
                                    "id": userDetails.user_id,
                                    "profile_type": userDetails.profile_type,
                                    "pic": userDetails.pic,
                                    "email": userDetails.email,
                                    "name": userDetails.name
                                }]
                            };
                            participantsData = participantsList;
                            return meetingData.data;
                        } else {
                            if (meetingData.is_non_working_hours) {
                                config.nonWorkingHourDisplayMessage = meetingData.message;
                                _this.nonWorkingHoursChatBox(config);
                            }
                        }
                    });
                }
            }).then(function (meeting) {
                if (!meeting) {
                    return;
                }
                var activity = {
                    'type': 'page visit',
                    'page': 'chat'
                };
                _userservice2.default.log(activity);
                _reactDom2.default.render(_react2.default.createElement(
                    _chat2.default,
                    {
                        initialMessage: client.initialMessage,
                        meetingId: meeting.id,
                        chatteeId: userDetails.user_id,
                        chatteeName: userDetails.name,
                        position: style.position,
                        skinName: style.skinName,
                        user_type: user_type,
                        chatElement: ele,
                        participants: participantsData,
                        user_pic: userDetails.pic,
                        displayMode: displayMode,
                        showHeader: showHeader,
                        showBody: showBody,
                        showFooter: showFooter,
                        width: width,
                        height: height,
                        mask_user_events: mask_user_events,
                        mask_user_typing_text: mask_user_typing_text },
                    'meeting ',
                    meeting.id,
                    'joined'
                ), document.getElementById(ele));
            }).catch(function (err) {
                _reactDom2.default.unmountComponentAtNode(document.getElementById(ele));
                throw new Error("Unable to load chat " + err.toString());
            });
        };

        this.loadAgentChat = function (config) {
            var ele = config.container;
            _reactDom2.default.render(_react2.default.createElement(_dock2.default, null), document.getElementById(ele));
        };

        this.getLiveMeetings = function () {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.getLiveChats().then(function (res) {
                    console.log("Live meeting api call res :", res);
                    resolve(res);
                });
            });
        };

        this.getLiveVisitors = function () {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.getLiveVisitors().then(function (res) {
                    console.log("Live visitors api call res :", res);
                    resolve(res);
                });
            });
        };

        this.getChatReports = function (options) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.getChatReports(options).then(function (res) {
                    console.log("Chat Reports api call res :", res);
                    resolve(res);
                });
            });
        };

        this.chatReportsDownload = function (options) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.chatReportsDownload(options).then(function (res) {
                    console.log("Chat Reports Download api call res :", res);
                    resolve(res);
                });
            });
        };

        this.chatTranscriptDownload = function (meetingId, mode) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.chatTranscriptDownload(meetingId, mode).then(function (res) {
                    console.log("Chat Transcript Download api call res :", res);
                    resolve(res);
                });
            });
        };

        this.getChatHistoryMessages = function (meetingId) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.getChatHistoryMessages(meetingId).then(function (res) {
                    console.log("Chat History Messages api call res :", res);
                    resolve(res);
                });
            });
        };

        this.getContacts = function () {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.getContacts().then(function (res) {
                    console.log("Get contacts res .. :", res);
                    resolve(res);
                });
            });
        };

        this.greetUser = function (options) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.greetUser(options).then(function (res) {
                    console.log("Greet User res .. :", res);
                    resolve(res);
                });
            });
        };

        this.joinMeetingRequest = function (meetingId) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.joinMeetingRequest(meetingId).then(function (res) {
                    console.log(res);
                    if (res.data) {
                        (0, _dock.Dock)().addDeckRequest(res.data.meeting_details, res.data.participants);
                    }
                    resolve(res);
                });
            });
        };

        this.updateVisitorNetworkStatus = function (user_details) {
            (0, _dock.Dock)().updateVisitorNetworkStatus(user_details);
        };

        this.contactNetworkStatusChange = function (contact_details) {
            if ((0, _contacts.Contacts)()) {
                (0, _contacts.Contacts)().contactNetworkStatusChange(contact_details);
            }
        };

        this.clearSession = function () {
            var userData = _userservice2.default.getUser();
            if (userData && userData.offline_packet && _lib2.default.isMqttConnected()) {
                userData.offline_packet.payload = JSON.stringify(userData.offline_packet.payload);
                _lib2.default.publish(userData.offline_packet);
            }
            _this.closeMqttConnection();
            if (userData && userData.type === Constants.USER_TYPE.AGENT) {
                (0, _dock.Dock)().clearDocker();
            }
        };

        this.closeMqttConnection = function () {
            _lib2.default.disconnect();
        };

        this.systemInviteAcknowledge = function (url, options) {
            return new Promise(function (resolve, reject) {
                _apiservice2.default.systemInviteAcknowledge(url, options).then(function (res) {
                    console.log(" res .. :", res);
                    resolve(res);
                });
            });
        };

        this.systemInviteJoin = function (url, options) {
            return new Promise(function (resolve, reject) {
                (0, _helpers.ajax)(url, 'POST', options, false).then(function (res) {
                    if (res.data) {
                        (0, _dock.Dock)().addDeckRequest(res.data.meeting_details, res.data.participants);
                    }
                    resolve(res);
                }).catch(function (err) {
                    return reject(err);
                });
            });
        };

        this.isMeetingOpen = function (meetingId) {
            return (0, _dock.isMeetingOpen)(meetingId);
        };
    }

    _createClass(ChatService, [{
        key: 'initialization',
        value: function initialization(mqttclient, callBacks) {
            var config = {
                "mqttService": mqttclient,
                "apiService": _apiservice2.default
            };
            (0, _helpers.setChatConfig)(config);
        }
    }]);

    return ChatService;
}();

exports.default = new ChatService();


// WEBPACK FOOTER //
// ../chat/lib/services/chatservice.js